import React, { useRef, useState } from 'react'
import Input from './Input'

interface Props {
  onSubmit: ({ name, description, image }: { name: string; description: string; image: string }) => void
  buttonLabel?: string
  image?: string
  name?: string
  description?: string
}

const UnitModal = ({ onSubmit, buttonLabel = 'Create', ...props }: Props) => {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const [image, setImage] = useState<string | null>(props.image || null)
  const [name, setName] = useState<string | null>(props.name || null)
  const [description, setDescription] = useState<string | null>(props.description || null)

  const createUnit = () => {
    if (!name || !description || !image) return
    onSubmit({ name, description, image })
  }

  return (
    <div>
      <div className="h-20" />
      <div className="bg-white rounded-md p-4 max-w-[27rem] w-screen">
        <h2 className="text-24 font-semibold">Create New Unit</h2>
        <div className="flex flex-col gap-4 mt-4">
          <Input
            label="Name"
            bgColor="white"
            color="darkIceBlue"
            value={name || ''}
            onChange={(e) => setName(e.target.value)}
          />
          <Input
            label="Description"
            bgColor="white"
            color="darkIceBlue"
            value={description || ''}
            onChange={(e) => setDescription(e.target.value)}
          />

          <div className="flex justify-end">
            <div onClick={() => fileInputRef.current?.click()} className="cursor-pointer">
              <input
                onChange={(e) => {
                  const file = e.target.files?.[0]
                  const reader = new FileReader()
                  reader.onload = (e) => {
                    const base64String = e.target?.result
                    setImage(base64String as string)
                  }
                  if (file) {
                    reader.readAsDataURL(file)
                  }
                }}
                type="file"
                ref={fileInputRef}
                className="hidden"
                accept=".jpg, .jpeg, .png"
              />
              <img
                className="w-24 h-24 rounded-full border-2 border-slateGray"
                src={
                  image ||
                  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ4f2X1fgjb1aD0oMN7qEF08stVzgu_y6J_OQ&s'
                }
                alt="profile"
              />
              <div className="h-3" />
              <button className="font-sans text-16 font-semibold text-slateGray border-2 border-slateGray rounded-lg p-4">
                Upload
              </button>
            </div>
          </div>
        </div>
        <div className="flex justify-end mt-4">
          <button onClick={createUnit} className="bg-slateGray px-4 py-2 rounded-md text-white font-semibold">
            {buttonLabel}
          </button>
        </div>
      </div>
    </div>
  )
}

export default UnitModal
